import { Platform } from '@angular/cdk/platform';

import { createSelector } from '@ngrx/store';

import { deviceDetectorStoreFeature } from './device-detector.state';
import { DeviceType, NativeAppType } from '../../types/device-types';

// !!! doplniť potrebné selektory (ak je možné stav vypočítať, radšej vytvoriť selektor, ako zapisovať do state)

const { selectDeviceType, selectIsMobileOS, selectNativeAppType, selectPlatform, selectIsTabletBreakpoint, selectIsMacOs } =
  deviceDetectorStoreFeature;

const selectIsMobile = createSelector(selectDeviceType, (s) => s === DeviceType.MOBILE);
const selectIsDesktop = createSelector(selectDeviceType, (s) => s === DeviceType.DESKTOP);
const selectIsFirefox = createSelector(selectPlatform, (s) => !!s && s.includes('FIREFOX' as keyof Platform));
const selectIsSafari = createSelector(selectPlatform, (s) => !!s && s.includes('SAFARI' as keyof Platform));
const selectIsIOS = createSelector(selectPlatform, (s) => !!s && s.includes('IOS' as keyof Platform));
const selectIsIOSNative = createSelector(selectNativeAppType, (nativeAppType) => {
  return nativeAppType === NativeAppType.IOS;
});
const selectIsAndroidNative = createSelector(selectNativeAppType, (nativeAppType) => {
  return nativeAppType === NativeAppType.ANDROID;
});
const selectIsIosAndIsNativeApp = createSelector(selectIsIOS, selectNativeAppType, (isIOS, nativeAppType) => {
  return {
    isIOS,
    isNativeIOS: nativeAppType === NativeAppType.IOS,
  };
});

export const fromDeviceDetector = {
  selectDeviceType,

  selectIsMobile,
  selectIsDesktop,
  selectIsTabletBreakpoint,
  selectIsMobileOS,
  selectIsFirefox,
  selectIsSafari,
  selectIsIOS,
  selectIsMacOs,
  selectNativeAppType,
  selectIsIOSNative,
  selectIsAndroidNative,
  selectIsIosAndIsNativeApp,
};
